import { createApp } from 'vue'
import { createGtm } from "vue-gtm";
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import SvgSprite from 'vue-svg-sprite';
import axios from 'axios'
import VueAxios from 'vue-axios'
const VueScrollTo = require('vue-scrollto');
window.ClipboardJS = require("clipboard");
window.toastr = require('toastr');
window.sharer = require('sharer.js');

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const app = createApp(App)
    .use(store)
    .use(SvgSprite,  {
        url: './svg-sprites/main.svg',
        class: 'icon',
    })
    .use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    })
    .use(VueAxios, axios)
    .use(router)

// Only initialise GTM when a valid container ID is provided.
// Without this guard, createGtm({ id: undefined }) throws at startup
// and the whole app fails to mount (blank page).
const gtmId = process.env.VUE_APP_GTM_ID;
if (gtmId && /^GTM-/.test(gtmId)) {
    app.use(
        createGtm({
            id: gtmId,
            enabled: process.env.VUE_APP_GTM_ENABLED === 'true',
            vueRouter: router,
        })
    );
}

app.mount('#app')
